import { createTyper } from "@mobx/services/http";
import { IMinerFullInfo3 } from "@mobx/store/locations/types";
import { castResponse, Method, RecordResponse, RequestArgs, RequestHandle } from "wl-net";

export const GetFullMinerInfo_RequestTypes = createTyper({
  makeRequest(
    handle: RequestHandle,
    id: number,
    admin?: boolean
  ): RequestArgs<{ id: string; full: boolean }> {
    const params = { id: `${id}`, full: true };
    return {
      handle,
      method: Method.Post,
      URL: `/${admin ? "admin" : "user"}/miner/info`,
      payload: params,
    };
  },

  makeResponse: castResponse<RecordResponse<IMinerFullInfo3>>,
});

export type MinerControlAction3 = "stop" | "start" | "restart" | "reset";

export const MinerControl_RequestTypes = createTyper({
  makeRequest(handle: RequestHandle, ctrl: MinerControlAction3, miners: number[]) {
    const url =
      ctrl === "reset" ? `/admin/miner/reset` : `/admin/miner/control/${ctrl}`;
    const m = miners.join(",");
    const params = ctrl === "reset" ? { id: m } : { miner: m };
    return {
      handle,
      method: Method.Post,
      URL: url,
      payload: params,
    }
  },
});

